import { z } from "zod";

const captchaSettingsZodObject = z.object({
    _id: z.literal("captcha_settings"),
    _type: z.literal("CAPTCHA_SETTINGS"),
    // Phone number country codes requiring captcha
    // Example: [46, 47]
    countryCodesRequiringCaptcha: z.array(z.number()),
    // Phone numbers without last 4 digits requiring captcha
    // Example: ["+4620202", "+4720202"] would capture
    // +4620202**** and +4720202****
    numberSeriesRequiringCaptcha: z.array(z.string()),
});

type CaptchaSettings = z.infer<typeof captchaSettingsZodObject>;

const captchaSettingsZodScheme =
    captchaSettingsZodObject as z.ZodSchema<CaptchaSettings>;

export { captchaSettingsZodObject, captchaSettingsZodScheme };
export type { CaptchaSettings };
